(() => {
  const KEY = "tm_cart_discount_countdown_start_v1";

  const now = () => Date.now();
  const pad2 = (n) => String(n).padStart(2, "0");
  const fmt = (sec) => `${pad2(Math.floor(sec / 60))}:${pad2(sec % 60)}`;

  const getStart = () => {
    const v = localStorage.getItem(KEY);
    const ts = v ? parseInt(v, 10) : NaN;
    return Number.isFinite(ts) ? ts : null;
  };

  const setStart = (ts) => localStorage.setItem(KEY, String(ts));
  const clearStart = () => localStorage.removeItem(KEY);

  async function fetchCartJSON() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  function setNodeCartState(node, hasItems) {
    node.setAttribute("data-cart-has-items", hasItems ? "1" : "0");
  }

  function initNode(node) {
    if (!node) return;

    const minutes = parseInt(node.getAttribute("data-minutes") || "10", 10);
    const timeEl = node.querySelector("[data-tm-time]");
    if (!timeEl) return;

    const hasItems = node.getAttribute("data-cart-has-items") === "1";

    // cart boşsa gizle + reset
    if (!hasItems) {
      if (node.__tmTimer) clearInterval(node.__tmTimer);
      node.__tmTimer = null;
      node.__tmInited = false;
      node.style.display = "none";
      clearStart();
      return;
    }

    node.style.display = "";

    // zaten çalışıyorsa tekrar interval açma
    if (node.__tmInited && node.__tmTimer) return;
    node.__tmInited = true;

    let start = getStart();
    if (!start) {
      start = now();
      setStart(start);
    }

    const endAt = start + minutes * 60 * 1000;

    const tick = () => {
      const remainingMs = endAt - now();
      const remainingSec = Math.max(0, Math.ceil(remainingMs / 1000));
      timeEl.textContent = fmt(remainingSec);

      if (remainingSec <= 120 && remainingSec > 0) node.classList.add("is-urgent");
      else node.classList.remove("is-urgent");

      if (remainingSec <= 0) {
        node.classList.add("is-expired");
        timeEl.textContent = "00:00";
      } else {
        node.classList.remove("is-expired");
      }
    };

    tick();
    node.__tmTimer = setInterval(tick, 250);
  }

  function initAll(root = document) {
    root.querySelectorAll("[data-tm-countdown]").forEach(initNode);
  }

  // tek yerden senkron
  let syncQueued = false;
  function syncCountdownWithCartDebounced() {
    if (syncQueued) return;
    syncQueued = true;

    setTimeout(async () => {
      syncQueued = false;

      const cart = await fetchCartJSON();
      if (!cart) return;

      const hasItems = (cart.item_count || 0) > 0;

      document.querySelectorAll("[data-tm-countdown]").forEach((node) => {
        setNodeCartState(node, hasItems);
        initNode(node);
      });
    }, 60);
  }

  // drawer DOM değişimlerini de izle (cart drawer renderContents sonrası)
  function observeDrawer() {
    const drawer = document.querySelector("#MinimogCartDrawer");
    if (!drawer) return;

    const mo = new MutationObserver(() => initAll(drawer));
    mo.observe(drawer, { childList: true, subtree: true });
  }

  // Minimog event hook’ları
  function hookMinimogEvents() {
    // Ürün sepete eklenince
    document.addEventListener("product-ajax:added", () => {
      syncCountdownWithCartDebounced();
    });

    // Bazı temalarda event bulunabiliyor
    if (window.MinimogEvents && typeof window.MinimogEvents.on === "function" && window.MinimogTheme?.pubSubEvents) {
      try {
        window.MinimogEvents.on(window.MinimogTheme.pubSubEvents.openCartDrawer, () => {
          syncCountdownWithCartDebounced();
        });
        window.MinimogEvents.on(window.MinimogTheme.pubSubEvents.cartUpdate, () => {
          syncCountdownWithCartDebounced();
        });
      } catch (e) {}
    }

    // fallback
    window.addEventListener("cart:updated", () => syncCountdownWithCartDebounced());
  }

  document.addEventListener("DOMContentLoaded", () => {
    initAll(document);
    observeDrawer();
    hookMinimogEvents();

    // ilk yüklemede de gerçek state’e eşitle
    syncCountdownWithCartDebounced();
  });
})();
